import { Injectable } from '@angular/core';

import { Principal } from './shared/auth/principal.service';
import { AuthServerProvider } from './shared/auth/auth-jwt.service';
import { User } from './shared/auth/user';
import { StateStorageService } from './shared/auth/state-storage.service';
import { Router } from '@angular/router';

@Injectable()
export class LoginService {

    constructor(
        private principal: Principal,
        private authServerProvider: AuthServerProvider,
        private stateStorageService: StateStorageService,
        private router: Router,
    ) { }

    login(credentials, callback?) {
        //this.logger.debug('login called in LoginService');
        //this.logger.debug('credentials.username...' + credentials.username)
        //this.logger.debug('credentials.password...' + credentials.password)
        const cb = callback || function () { };

        return new Promise((resolve, reject) => {
            this.authServerProvider.login(credentials).subscribe((data) => {
                this.principal.identity(true).then((account) => {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account !== null) {
                        //this.languageService.changeLanguage(account.langKey);
                        //this.logger.debug('account is not null' + JSON.stringify(account));
                    }
                    resolve(account);
                });
                return cb();
            }, (err) => {
                this.logout();
                reject(err);
                return cb(err);
            });
        });
    }

    loginWithToken(jwt, rememberMe) {
        return this.authServerProvider.loginWithToken(jwt, rememberMe);
    }
    userLoggedIn: User;
    logout() {
        this.authServerProvider.logout().subscribe();
        this.userLoggedIn = JSON.parse(localStorage.getItem("sessuser")) as User;
        //this.logger.debug('this.userLoggedIn >>>', this.userLoggedIn);
        sessionStorage.clear();
        localStorage.clear();
        if (this.userLoggedIn != undefined) {
            localStorage.setItem("prevUser", this.userLoggedIn.user_id);
        }
        localStorage.setItem("lang", "en");
        this.principal.authenticate(null);
    }

    redirectTo(user: User, val) {
        const redirect = this.stateStorageService.getUrl();
        //this.logger.debug('redirect...1' + redirect)
        let redirectLink = redirect;
        if (this.checkRoles(user.roles, 'ROLE_MANAGEBILLERS')) {
            redirectLink = '/dashboard/admin';
        } else if (this.checkRoles(user.roles, 'ROLE_BILLER')) {
            redirectLink = '/dashboard/biller';
        } else if (this.checkRoles(user.roles, 'ROLE_BANK')) {
            redirectLink = '/dashboard/bank';
        } else if (this.checkRoles(user.roles, 'ROLE_MAILINBOX')) {
            redirectLink = '/dashboard/grs';
        } else if (this.checkRoles(user.roles, 'ROLE_MERCHANT')) {
            redirectLink = '/report/merchant-transaction-data';
        } else if (this.checkRoles(user.roles, 'ROLE_SYNDICATE')) {
            //redirectLink = '/report/syndicate-transaction-data';
            redirectLink = '/dashboard/assisted';
        } else if (this.checkRoles(user.roles, 'ROLE_RAISECMPLN')) {
            redirectLink = '/raise-complain';
        } else if (this.checkRoles(user.roles, 'ROLE_VIEWCMPLN')) {
            redirectLink = '/view-complaints';
        } else if (this.checkRoles(user.roles, 'ROLE_ACTIONCMPLN')) {
            redirectLink = '/view-complaints';
        } else if (this.checkRoles(user.roles, 'ROLE_RAISETKT')) {
            redirectLink = '';
        } else if (this.checkRoles(user.roles, 'ROLE_VIEWTKT')) {
            redirectLink = 'grs/view-tickets';
        } else if (this.checkRoles(user.roles, 'ROLE_ACTIONTKT')) {
            redirectLink = '';
        } else if (this.checkRoles(user.roles, 'ROLE_RAISEDDSPT')) {
            redirectLink = '/dms/raise-dispute';
        } else if (this.checkRoles(user.roles, 'ROLE_VIEWDSPT')) {
            redirectLink = '/dms/view-dispute';
        } else if (this.checkRoles(user.roles, 'ROLE_VIEWDDSPT')) {
            redirectLink = 'dms/view-direct-dispute';
        } else if (this.checkRoles(user.roles, 'ROLE_ACTIONDSPT')) {
            redirectLink = '';
        } else if (this.checkRoles(user.roles, 'ROLE_MANAGEEKPAYCHARGE')) {
            redirectLink = '/view-ekpay-charge';
        } else if (this.checkRoles(user.roles, 'ROLE_MANAGEBANNERS')) {
            redirectLink = '/view-banners';
        } else if (this.checkRoles(user.roles, 'ROLE_FEEDBACK')) {
            redirectLink = '/feedbacks';
        } else if (this.checkRoles(user.roles, 'ROLE_MANAGEADJUSTMENT')) {
            redirectLink = '/settlement';
        } else if (this.checkRoles(user.roles, 'ROLE_GATEWAY')) {
            redirectLink = '/reconciliation/results';
        } else if (this.checkRoles(user.roles, 'AGENT_MANAGEMENT_VIEW') || this.checkRoles(user.roles, 'AGENT_MANAGEMENT_OPERATION')) {
          redirectLink = '/agent/wallet-list';
        } else if (this.checkRoles(user.roles, 'COMMISSION_OPERATION') || this.checkRoles(user.roles, 'COMMISSION_VIEW')) {
          redirectLink = '/agent/view-commission-setting';
        } else if (this.checkRoles(user.roles, 'TOP_UP_VIEW') || this.checkRoles(user.roles, 'TOP_UP_OPERATION')) {
          redirectLink = '/agent/top-up-list';
        } else if (this.checkRoles(user.roles, 'PAYMENT_HISTORY_OPERATION') || this.checkRoles(user.roles, 'PAYMENT_HISTORY_VIEW')) {
          redirectLink = '/agent/payment-history';
        } else if (this.checkRoles(user.roles, 'SETTLEMENT_OPERATION') || this.checkRoles(user.roles, 'SETTLEMENT_VIEW')) {
          redirectLink = '/agent/merchant-commission-settlement';
        }else if (this.checkRoles(user.roles, 'REPORT_VIEW') ) {
          redirectLink = '/report/pg-transaction-data';
        } else {
            redirectLink = '/dashboard/blank';
        }
        //this.logger.debug('redirectLink...' + redirectLink)
        if (redirectLink) {
            if (val == null) {
                this.stateStorageService.storeUrl(null);
                this.router.navigate([redirectLink]);
            } else {
                this.stateStorageService.storeUrl(null);
                // this.router.navigate([redirectLink]);
                window.location.reload();
            }
        }
    }
    checkRoles(rolesArr, roleName) {
        let flagRoles = false;
        for (let i = 0; i < rolesArr.length; i++) {
            if (rolesArr[i].trim() == roleName.trim()) {
                flagRoles = true;
                break;
            }
        }
        return flagRoles;
    }
}



// WEBPACK FOOTER //
// ./src/app/login.service.ts